var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-list-item',{scopedSlots:_vm._u([(_vm.$scopedSlots.actions)?{key:"actions",fn:function(){return [_vm._t("actions")]},proxy:true}:null,(_vm.$scopedSlots.extra)?{key:"extra",fn:function(){return [_vm._t("extraContent")]},proxy:true}:null],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }